<template>
    <div class="not-found">
        <div class="nf-top">
            404
        </div>
        <div class="nf-bottom">
            Aradığınız sayfa bulunamadı
        </div>
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "NotFound",
        mounted() {
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'subPage');
        }
    }
</script>

<style lang="scss">
.not-found {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    .nf-top {
        color: white;
        font-size: 17em;
        text-align: center;
        font-weight: bolder;
    }

    .nf-bottom {
        color: white;
        font-size: 16px;
        text-align: center;
    }
}
</style>